(() => {
  const dialog = document.getElementById('mlf-final-sale-dialog');
  if (!dialog) return;
  let trigger;
  document.addEventListener('click', event => {
    const button = event.target.closest?.('[data-final-sale-info]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    trigger = button;
    if (!dialog.open) dialog.showModal();
  }, true);
  dialog.querySelector('[data-final-sale-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    if (trigger?.isConnected) trigger.focus({ preventScroll:true });
  });
})();
